/*
 * @Author:
 * @LastEditTime: 2022-01-10 14:41:15
 * @Description:查看详情panel勾选显示功能混入
 */

/**
 * This provides mixins used for common functions in the Vue components.
 * Before you begin to used it , plz inject this mixins in the components
 * like mixins: [PanelMixins]
 *
 * @mixin
 */
const PanelMixins = {
  // 获取需要显示的panel列表
  getPanelList() {
    let list = []
    let safetyPanelObj = null
    if (window.localStorage.getItem('safetyPanelObj')) {
      safetyPanelObj = JSON.parse(window.localStorage.getItem('safetyPanelObj'))
    } else {
      window.localStorage.setItem('safetyPanelObj', JSON.stringify(this.safetyPanelObj))
    }
    if (
      window.localStorage.getItem('safetyPanelObj') ||
      safetyPanelObj[this.currentPanelPageName]?.length > 0
    ) {
      list = this.moduleList.filter((item) => {
        return item.checked
      })
      window.localStorage.setItem('safetyPanelObj', JSON.stringify(this.safetyPanelObj))
    } else {
      list = JSON.parse(window.localStorage.getItem('safetyPanelObj'))
    }
    return list
  },
  /**
   * 计算当前激活面板
   * @param {*} e 更新后的值
   * @param {*} item 当前点击的panel元素
   * @param {*} index 当前点击的panel元素的索引
   */
  moduleChange(e, item) {
    // 判断当前取消的面板是否激活
    if (this.activeModule === item.module) {
      // 取消激活的面板
      this.$nextTick(() => {
        this.activeModule = this.moduleShowList[0].module
      })
    }
  },
}
export default {
  data() {
    return {
      // 所有详情面板对象
      safetyPanelObj: {
        unitFilesPanel: [], // safetyPanelObj.unitFilesPanel,表示的是单位档案详情面板
      },
    }
  },
  computed: {
    // 去除基本信息
    moduleNeedList() {
      return this.moduleList.filter((item) => {
        return item.module !== '0'
      })
    },
    // 是否显示过滤菜单
    isShowDropdownMenu() {
      return this.moduleList.length > 1
    },
    // 过滤未选中的面板
    moduleShowList() {
      const list = this.getPanelList()
      this.$set(this.safetyPanelObj, this.currentPanelPageName, list)
      return this.safetyPanelObj[this.currentPanelPageName]
    },
  },
  methods: PanelMixins,
}
